export default "__VITE_ASSET__C6fZVRVJ__"